import type { IGameTop } from "../../../api_types";

export const flyReference = (data: IGameTop) => {
  const spanStart = data.ClockStart.replace(/T/g, " ");
  const spanStop = data.ClockStop.replace(/T/g, " ");
  const firstBegin = data.ClockRestBegin.replace(/T/g, " ");
  const firstEnd = data.ClockRestEnd.replace(/T/g, " ");
  const secondBegin = data.ClockTwoRestBegin.replace(/T/g, " ");
  const secondEnd = data.ClockTwoRestEnd.replace(/T/g, " ");
  const realDistance =
    typeof data.PlaceDistance === "string"
      ? parseInt(data.PlaceDistance)
      : data.PlaceDistance;

  /*
    nonsensical, spanStart and spanStop are clearly strings 
    (as indicated by the fact that .replace is being used),
    yet the original author (Gray) used isNaN() on it, which
    is always true (although typescript doesn't allow it)
   */
  if (
    isNaN(spanStart.replace(/-/g, "/") as any) &&
    isNaN(spanStop.replace(/-/g, "/") as any)
  ) {
    let result = null;
    if (realDistance > 0) {
      const dateNow = new Date().getTime();
      const dateStart = new Date(spanStart.replace(/-/g, "/")).getTime();
      const dateStop = new Date(spanStop.replace(/-/g, "/")).getTime();
      if (dateNow <= dateStop) {
        let dateRunMinutes = 0;
        const restOne = data.ClockRest;
        const restOneBegin = new Date(firstBegin.replace(/-/g, "/")).getTime();
        const restOneEnd = new Date(firstEnd.replace(/-/g, "/")).getTime();
        const restTwo = data.ClockTwoRest;
        const restTwoBegin = new Date(secondBegin.replace(/-/g, "/")).getTime();
        const restTwoEnd = new Date(secondEnd.replace(/-/g, "/")).getTime();
        if (restOne === 1 && dateNow > restOneBegin) {
          if (dateNow > restOneEnd) {
            if (restTwo === 1 && dateNow > restTwoBegin) {
              if (dateNow > restTwoEnd) {
                dateRunMinutes =
                  (dateNow -
                    dateStart -
                    (restOneEnd - restOneBegin) -
                    (restTwoEnd - restTwoBegin)) /
                  60000;
              } else {
                dateRunMinutes =
                  (restTwoBegin - dateStart - (restOneEnd - restOneBegin)) /
                  60000;
              }
            } else {
              dateRunMinutes =
                (dateNow - dateStart - (restOneEnd - restOneBegin)) / 60000;
            }
          } else {
            dateRunMinutes = (restOneBegin - dateStart) / 60000;
          }
        } else {
          dateRunMinutes = (dateNow - dateStart) / 60000;
        }
        if (dateRunMinutes > 5000) {
          result = "大于预期";
        } else if (dateRunMinutes < 0) {
          result = "0 分钟";
        } else {
          result = dateRunMinutes.toFixed(3);
        }
      }
    }
    return result;
  }
};
export const refreshSpanSpeed = (data: IGameTop) => {
  const spanStart = data.ClockStart.replace(/T/g, " ");
  const spanStop = data.ClockStop.replace(/T/g, " ");
  const firstBegin = data.ClockRestBegin.replace(/T/g, " ");
  const firstEnd = data.ClockRestEnd.replace(/T/g, " ");
  const secondBegin = data.ClockTwoRestBegin.replace(/T/g, " ");
  const secondEnd = data.ClockTwoRestEnd.replace(/T/g, " ");
  const realDistance =
    typeof data.PlaceDistance === "string"
      ? parseInt(data.PlaceDistance)
      : data.PlaceDistance;

  /* same as above */
  if (
    isNaN(spanStart.replace(/-/g, "/") as any) &&
    isNaN(spanStop.replace(/-/g, "/") as any)
  ) {
    let result = null;
    if (realDistance > 0) {
      const dateNow = new Date().getTime();
      const dateStart = new Date(spanStart.replace(/-/g, "/")).getTime();
      const dateStop = new Date(spanStop.replace(/-/g, "/")).getTime();
      if (dateNow <= dateStop) {
        let dateRunMinutes = 0;
        const restOne = data.ClockRest;
        const restOneBegin = new Date(firstBegin.replace(/-/g, "/")).getTime();
        const restOneEnd = new Date(firstEnd.replace(/-/g, "/")).getTime();
        const restTwo = data.ClockTwoRest;
        const restTwoBegin = new Date(secondBegin.replace(/-/g, "/")).getTime();
        const restTwoEnd = new Date(secondEnd.replace(/-/g, "/")).getTime();
        if (restOne === 1 && dateNow > restOneBegin) {
          if (dateNow > restOneEnd) {
            if (restTwo === 1 && dateNow > restTwoBegin) {
              if (dateNow > restTwoEnd) {
                dateRunMinutes =
                  (dateNow -
                    dateStart -
                    (restOneEnd - restOneBegin) -
                    (restTwoEnd - restTwoBegin)) /
                  60000;
              } else {
                dateRunMinutes =
                  (restTwoBegin - dateStart - (restOneEnd - restOneBegin)) /
                  60000;
              }
            } else {
              dateRunMinutes =
                (dateNow - dateStart - (restOneEnd - restOneBegin)) / 60000;
            }
          } else {
            dateRunMinutes = (restOneBegin - dateStart) / 60000;
          }
        } else {
          dateRunMinutes = (dateNow - dateStart) / 60000;
        }
        if (dateRunMinutes > 5000) {
          result = "大于预期";
        } else {
          if (dateRunMinutes < 0) {
            result = "0 分钟";
          } else {
            result = dateRunMinutes.toFixed(3) + " 分钟";
          }
        }
        const realSpeed = realDistance / dateRunMinutes;
        if (realSpeed > 3000) {
          result = "大於 3000";
        } else {
          if (realSpeed < 100) {
            result = "低於 100";
          } else {
            result = realSpeed.toFixed(3);
          }
        }
      } else {
        result = "已结束";
      }
    }
    return result;
  }
};
